import styles from "./CustomInput.module.css";

export const CustomInput = ({
  value,
  placeholder,
  onChangeHandler = () => {},
  after,
  inputMode = "text",
}: {
  value: string;
  placeholder: string;
  onChangeHandler?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  after?: React.ReactElement;
  inputMode:
    | "none"
    | "text"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal"
    | "search";
}) => {
  return (
    <div className={styles.row}>
      <div className={styles.inputWrapper}>
        <input
          className={styles.input}
          type="text"
          inputMode={inputMode}
          value={value}
          onChange={onChangeHandler}
          placeholder={placeholder}
        />
        {after && <span className={styles.suffix}>{after}</span>}
      </div>
    </div>
  );
};
